import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import SEO from "../../components/SEO/SEO";

interface NewsletterStatusPageProps {
  path: string;
  pageTitle: string;
  seoTitle: string;
  seoDescription: string;
  icon: string;
  heading: string;
  message: string;
}

const NewsletterStatusPage: React.FC<NewsletterStatusPageProps> = ({
  path,
  pageTitle,
  seoTitle,
  seoDescription,
  icon,
  heading,
  message,
}) => {
  return (
    <Fragment>
      <SEO title={seoTitle} description={seoDescription} path={path} noindex />
      <div className="about-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle={pageTitle} pagesub={pageTitle} />
            <div className="error-page">
              <div className="container not-found-content">
                <div className="row justify-content-center">
                  <div className="col-lg-12">
                    <div className="contant-wrapper text-center">
                      <div className="error-page__text">
                        <span style={{ fontSize: 60 }}>{icon}</span>
                      </div>
                      <div className="error-page__content mb-50">
                        <h2>{heading}</h2>
                        <p>{message}</p>
                        <div className="error-page-button">
                          <Link className="thm-btn agency-btn" to="/blog">
                            <span className="text">Back to Blog</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default NewsletterStatusPage;
